import { render, staticRenderFns } from "./LeoOrderDetail.vue?vue&type=template&id=22a358e0&scoped=true&"
import script from "./LeoOrderDetail.vue?vue&type=script&lang=js&"
export * from "./LeoOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeoOrderDetail.vue?vue&type=style&index=0&id=22a358e0&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a358e0",
  null
  
)

export default component.exports